import React from 'react'

const RowsContext = React.createContext({
  selectedRows: []
})

export default RowsContext